const global = {
  state: {
    mobile: '', //记录登陆手机号码
    updateInfo: {}, //输入的更改信息
    VerificationUserList: [], //修改密码时 获取的需要重置密码的用户列表
    VerifyUserId: '', //选中修改密码的用户id
    isWelcome: false, //只有登录进入首页才会显示欢迎回来的提示语
  },
  mutations: {
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_UPDATEINFO: (state, updateInfo) => {
      state.updateInfo = updateInfo;
    },
    SET_VERIFICATIONUSERLIST: (state, VerificationUserList) => {
      state.VerificationUserList = VerificationUserList;
    },
    SET_VERIFYUSERID: (state, VerifyUserId) => {
      state.VerifyUserId = VerifyUserId;
    },
    SET_ISWELCOME: (state, isWelcome) => {
      state.isWelcome = isWelcome;
    },
  },
  actions: {
    setMobile({ commit }, data) {
      commit('SET_MOBILE', data);
    },
    setUpdateInfo({ commit }, data) {
      commit('SET_UPDATEINFO', data);
    },
    setVerificationUserList({ commit }, data) {
      commit('SET_VERIFICATIONUSERLIST', data);
    },
    setVerifyUserId({ commit }, data) {
      commit('SET_VERIFYUSERID', data);
    },
    setIsWelcome({ commit }, data) {
      commit('SET_ISWELCOME', data);
    },
  },
};

export default global;
